import React, { useEffect } from "react";
import "./Anggota.css";
import DataHelper, {
  dataFoto,
  dataProgram,
  cardAnggota,
} from "../../dataHelper/DataHelper";
import AOS from "aos";
import "aos/dist/aos.css";

const Anggota = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  });

  return (
    <>
      <div className='container-anggota flex justfy-center flex-col items-center'>
        <p className='title-anggota' data-aos='fade-up'>
          keanggotaan
        </p>
        <div className='card-anggota'>
          {DataHelper &&
            cardAnggota.map((card, index) => (
              <div key={index} className='row-card-anggota'>
                <div className='box-anggota'>
                  <img
                    src={require(`../../assets/image/${card.img}`)}
                    alt=''
                    srcset=''
                    className='img-border'
                  />
                  <div className='col-second'>
                    <p className='name'>{card.title}</p>
                    <p className='name'>{card.jabatan}</p>
                  </div>
                </div>
                <div className='footer-cols'></div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Anggota;
